import React from "react";
import "./../../../style.scss";
import { TableRow, TableCell, withStyles } from "@material-ui/core";
import SpecialNeeds from "./SpecialNeeds";

const styles = {
  tableRowRoot: {
    height: "25px",
  },
  nameCellPadding: {
    paddingRight: "25px",
  },
  labelCell: {
    width: "125px",
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: "12px",
    lineHeight: "14px",
  },
  dataCellPickupInfo: {
    borderBottom: 0,
    fontWeight: 600,
    fontSize: 12,
    width: "80px",
    lineHeight: "17px",
    "&$lastTableCell": {
      paddingRight: "10px",
    },
  },
  lastTableCell: {
    paddingRight: "10px",
  },
  dualLastCell: {
    display: "inline-block",
    paddingLeft: "10px",
  },
  dualFirstCell: {
    display: "inline-block",
  },
  dualCellMiddle: {
    display: "inline-block",
    paddingRight: "10px",
    borderRight: "1px solid #D8D8D8",
  },
};

const RowList = ({ classes, data, stopData, specialNeeds }) => {
  const getCustomClass = (eachRow, index) => {
    if (eachRow.labels.length === 1) {
      return classes.dualFirstCell;
    } else if (eachRow.labels.length - 1 === index) {
      return classes.dualLastCell;
    }
    return classes.dualCellMiddle;
  };
  return (
    <>
      {data.map((eachRow, rowIndex) => (
        <TableRow className={classes.tableRowRoot} key={rowIndex}>
          <TableCell
            className={`${classes.nameCellPadding} ${classes.labelCell} ${classes.lastTableCell} tableCellName`}
          >
            {eachRow.labels.map((fieldName, cellIndex) => (
              <div
                className={getCustomClass(eachRow, cellIndex)}
                key={cellIndex}
              >
                {fieldName}
              </div>
            ))}
          </TableCell>
          <TableCell
            align="right"
            className={`${classes.dataCellPickupInfo} ${classes.lastTableCell} tableCellValue`}
          >
            {eachRow?.hasIconsListToRender ? (
              <SpecialNeeds
                specialNeeds={specialNeeds}
                values={eachRow.values}
                stopData={stopData}
              />
            ) : (
              eachRow.values.map((fieldValue, cellIndex) => (
                <div
                  className={getCustomClass(eachRow, cellIndex)}
                  key={cellIndex}
                >
                  {fieldValue}
                </div>
              ))
            )}
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default withStyles(styles)(RowList);
